import { render, staticRenderFns } from "./EasyDataTable.vue?vue&type=template&id=c066fb44&scoped=true"
import script from "./EasyDataTable.vue?vue&type=script&lang=js"
export * from "./EasyDataTable.vue?vue&type=script&lang=js"
import style0 from "./EasyDataTable.vue?vue&type=style&index=0&id=c066fb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c066fb44",
  null
  
)

export default component.exports